import { bool, func, string } from 'prop-types';
import React from 'react';

import Button from 'shared/components/button/Button';
import ChevronDown from 'shared/components/icon/ChevronDown';
import Event from 'shared/components/icon/Event';

const ToggleVisibilityButton = ({ visible, label, onClick }) => (
  <Button
    className="block-button block-button--action block-button--toggle"
    onClick={onClick}
  >
    <div className="block-button__inner">
      <div className="block-button__left">
        <Event />
        {label}
      </div>
      <div className="block-button__right">
        <ChevronDown className={visible ? 'active' : null} />
      </div>
    </div>
  </Button>
);

ToggleVisibilityButton.propTypes = {
  visible: bool.isRequired,
  label: string.isRequired,
  onClick: func.isRequired,
};

export default ToggleVisibilityButton;
